var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8786 16.1215L12.5856 8.829L5.29256 16.1215L4.93956 15.768C4.35356 15.1825 4.35356 14.2325 4.93906 13.647L12.5856 6L20.2321 13.647C20.8176 14.2325 20.8176 15.1825 20.2321 15.768L19.8786 16.1215Z",
    fill: "#F3BB90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseButton);
export default __webpack_public_path__ + "static/media/collapseButton.ff98e2054b7b5e3ab2909dafc9a52916.svg";
export { ForwardRef as ReactComponent };